import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { Color } from 'src/theme/color';

export const TextSection = ({ children, heading }: { children: React.ReactNode; heading: string }) => {
	return (
		<Flex flexDir="column" gap="10px">
			<Box fontWeight="bold">{heading}</Box>
			<Box
				fontSize="12px"
				color={Color.GRAY_2}
			>
				{children}
			</Box>
		</Flex>
	);
};
